/*globals jQuery:true*/
var debug = require('ingo-debug');

var loadJS = require('./load-script');

var InGo = require('./ingo-global');

var defaultJqueryUrl = 'https://cdn.ingo.me/widgets-loader/0.9.1/js/';



// Load jQuery if needed and then call the callback, use InGo.$ instead of global jQuery from now on
function getJQuery(options, ingoWidget, callback) {
  if(InGo.$) {
    return callback();
  }

  // first we try to use global jquery
  var jq = window.jQuery;

  if (jq && jq.fn && jq.fn.jquery) {//it looks like real jquery
    var ver = jq.fn.jquery.split('.');

    debug('getJQuery:', 'global jq', ver);

    for (var i = 0; i < ver.length; i++) {//XXX add util.map
      ver[i] = parseInt(ver[i], 10);
    }

    if (ver[0] > 1 || (ver[0] === 1 && ver[1] >= 7)) {
      InGo.$ = jq;
      InGo.$.fn.ingoWidget = InGo.$.fn.loaderWidget = ingoWidget;
      return callback();
    }
  }

  debug('getJQuery:', 'download jq');
  // second we load our own prepared version of jquery
  loadJS((options.href || defaultJqueryUrl) + 'jquery.min.js', function(err) {
    if(err) {
      throw err;
    }

    jq = jQuery.noConflict(true);
    InGo.$ = InGo.$ || jq;//check to do not override $ incase widget modify it

    InGo.$.fn.ingoWidget = InGo.$.fn.loaderWidget = ingoWidget;
    callback();
  });
}


module.exports = getJQuery;
